import logo from './ffxivmeteo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Knowledge Seeks No Man.
        </p>
        <a
          className="App-link"
          href="https://na.finalfantasyxiv.com/lodestone/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Journey
        </a>
      </header>
    </div>
  );
}

export default App;
